import React from "react";
import { useLocation } from "react-router-dom";
import { GetParam } from "../../pkg/query/getparam";
import { HOME } from "../../pkg/query/parameters";

const Footer = () => {
  const location = useLocation();
  const currentParam = GetParam(location.search);
  const isHomePage = currentParam === HOME;

  return (
    <>
      {/* 詳細ページのみタブメニューを表示 */}
      {!isHomePage && (
        <section className="section footer-tabs-section">
          <div className="container">
            <nav className="tabs is-boxed is-fullwidth mobile-responsive-tabs">
              <div className="container">
                <ul>
                  <li>
                    <a href="./index.html?view=touinnkaiso">当院開創</a>
                  </li>
                  <li>
                    <a href="./index.html?view=nannbokutyojidai">
                      南北朝時代
                    </a>
                  </li>
                  <li>
                    <a href="./index.html?view=gyouji">年中行事</a>
                  </li>
                  <li>
                    <a href="./index.html?view=gomaku">祈祷</a>
                  </li>
                  <li>
                    <a href="./index.html?view=kuyou">供養</a>
                  </li>
                  <li>
                    <a href="./index.html?view=oterataiken">お寺体験</a>
                  </li>
                  <li>
                    <a href="./index.html?view=hiwatari">火渡り修行</a>
                  </li>
                  <li>
                    <a href="https://www.google.com/maps/place/%E7%8E%89%E6%B3%89%E9%99%A2/@34.3030102,135.7281878,17z/data=!3m1!4b1!4m5!3m4!1s0x6006daebd1088d3b:0x167607ff0690a7d7!8m2!3d34.3030058!4d135.7303818?hl=ja" target="_blank" rel="noopener noreferrer">アクセス</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </section>
      )}

      <footer className="footer footer-animate" style={{ background: '#2c2c2c', color: 'rgba(255,255,255,0.7)', padding: '2rem 1.5rem' }}>
        <div className="content has-text-centered">
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', letterSpacing: '0.05em' }}>
            © 真言宗御室派玉泉院
            <br />
            All rights reserved
          </p>
          <div style={{ marginTop: '0.75rem' }}>
            <a href="https://www.facebook.com/gyokusenin/" style={{ color: 'rgba(255,255,255,0.5)' }}>
              <i className="fab fa-facebook-f"></i>
            </a>
            &nbsp;&nbsp;
            <a href="https://www.instagram.com/gyokusenin/" style={{ color: 'rgba(255,255,255,0.5)' }}>
              <i className="fab fa-instagram"></i>
            </a>
            &nbsp;&nbsp;
            <a href="https://lin.ee/v8jwj8W" style={{ color: 'rgba(255,255,255,0.5)' }}>
              <i className="fab fa-line"></i>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
